import { createElementVNode, defineComponent, inject, ref, onMounted, nextTick, watch, onBeforeUnmount, openBlock, createElementBlock, Fragment, mergeProps, unref, renderSlot, createTextVNode, createCommentVNode, createBlock, Teleport, normalizeClass, normalizeStyle } from 'vue';
import { getCookie, deleteCookie } from '../../../utils/cookies.mjs';
import { USER_MEMBERZONE, USER_REGISTRATION, USER_LOGIN, USER_LOGOUT } from '../../../utils/getConstant.mjs';

const _hoisted_1 = ["href"];
const _hoisted_2 = ["href"];
const _hoisted_3 = ["href"];
const _hoisted_4 = ["href"];
const _hoisted_5 = /* @__PURE__ */ createElementVNode("circle", {
  class: "tvb-sso-button_dialog-container-path",
  fill: "none",
  "stroke-width": "6",
  "stroke-linecap": "round",
  cx: "33",
  cy: "33",
  r: "30"
}, null, -1);
const _hoisted_6 = [
  _hoisted_5
];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["href"];
const __default__ = defineComponent({
  name: "TvbSsoButton"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    type: null,
    animate: null
  },
  emits: ["memberzone", "login", "click"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const env = inject("env");
    const isLogin = ref(!!getCookie("tvbcoms"));
    const iframeSrc = ref("");
    const iframeShow = ref(false);
    onMounted(() => {
      isLogin.value = checklogin();
    });
    const loginRegistrationEventListener = (e) => {
      console.log({ SSOEvent: e });
      const loginData = e.data;
      if (loginData === "memberzone_return") {
        iframeSrc.value = "";
        emits("memberzone");
      }
      if (/^redirect_url/.test(loginData) || loginData === "login_success") {
        if (loginData.includes("www.facebook.com")) {
          window.location.assign(loginData.replaceAll("redirect_url:", ""));
        } else if (loginData.includes("google")) {
          window.location.assign(loginData.replaceAll("redirect_url:", ""));
        } else {
          iframeSrc.value = "";
          isLogin.value = checklogin();
          emits("login");
          window.location.reload();
        }
      }
    };
    const checklogin = () => Boolean(getCookie("tvbcoms"));
    const memberzone = (event) => {
      event == null ? void 0 : event.preventDefault();
      iframeSrc.value = USER_MEMBERZONE(env || "prod");
      emits("click", "memberzone");
    };
    const registration = (event) => {
      event == null ? void 0 : event.preventDefault();
      iframeSrc.value = USER_REGISTRATION(env || "prod");
      emits("click", "registration");
    };
    const login = (event) => {
      event == null ? void 0 : event.preventDefault();
      iframeSrc.value = USER_LOGIN(env || "prod");
      emits("click", "login");
    };
    const logout = (event) => {
      event == null ? void 0 : event.preventDefault();
      deleteCookie("tvbcom");
      deleteCookie("tvbcoms");
      deleteCookie("user");
      deleteCookie("auto_login");
      emits("click", "logout");
      isLogin.value = false;
      nextTick(() => window.location.assign(USER_LOGOUT(env || "prod")));
    };
    const onSsoload = () => {
      iframeShow.value = true;
    };
    onMounted(() => window.addEventListener("message", loginRegistrationEventListener, false));
    watch(iframeSrc, (iframeSrc2) => {
      if (!iframeSrc2)
        iframeShow.value = false;
      window.document.querySelector("body").style.overflow = iframeSrc2 ? "hidden" : "";
    });
    onBeforeUnmount(
      () => window.removeEventListener("message", loginRegistrationEventListener, false)
    );
    expose({
      memberzone,
      registration,
      login,
      logout,
      checklogin,
      onSsoload,
      iframeShow
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        props.type === "registration-memberzone" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          isLogin.value ? (openBlock(), createElementBlock("a", mergeProps({
            key: 0,
            href: unref(USER_MEMBERZONE)(unref(env) || "prod")
          }, _ctx.$attrs, {
            title: "\u6703\u54E1\u5C08\u5340",
            onClick: memberzone
          }), [
            _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", {
              key: 0,
              isLogin: isLogin.value,
              type: "memberzone"
            }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(" \u6703\u54E1\u5C08\u5340 ")
            ], 64))
          ], 16, _hoisted_1)) : (openBlock(), createElementBlock("a", mergeProps({
            key: 1,
            href: unref(USER_REGISTRATION)(unref(env) || "prod")
          }, _ctx.$attrs, {
            title: "\u65B0\u7528\u6236?",
            onClick: registration
          }), [
            _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", {
              key: 0,
              isLogin: isLogin.value,
              type: "registration"
            }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(" \u65B0\u7528\u6236? ")
            ], 64))
          ], 16, _hoisted_2))
        ], 64)) : createCommentVNode("v-if", true),
        props.type === "login-logout" ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          isLogin.value ? (openBlock(), createElementBlock("a", mergeProps({
            key: 0,
            href: unref(USER_MEMBERZONE)(unref(env) || "prod")
          }, _ctx.$attrs, {
            title: "\u6703\u54E1\u5C08\u5340",
            onClick: memberzone
          }), [
            _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", {
              key: 0,
              isLogin: isLogin.value,
              type: "memberzone"
            }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(" \u6703\u54E1\u5C08\u5340 ")
            ], 64))
          ], 16, _hoisted_3)) : (openBlock(), createElementBlock("a", mergeProps({
            key: 1,
            href: unref(USER_LOGIN)(unref(env) || "prod")
          }, _ctx.$attrs, {
            title: "\u767B\u5165",
            onClick: login
          }), [
            _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", {
              key: 0,
              isLogin: isLogin.value,
              type: "login"
            }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(" \u767B\u5165 ")
            ], 64))
          ], 16, _hoisted_4))
        ], 64)) : createCommentVNode("v-if", true),
        (openBlock(), createBlock(Teleport, { to: "body" }, [
          createElementVNode("div", {
            class: normalizeClass(["tvb-sso-button_dialog animate__fadeIn", { show: !!iframeSrc.value, "is-login": isLogin.value }])
          }, [
            createElementVNode("div", {
              class: normalizeClass(["tvb-sso-button_dialog-container", [__props.animate ? __props.animate : "animate__fadeInDown"]])
            }, [
              (openBlock(), createElementBlock("svg", {
                class: "tvb-sso-button_dialog-container-spinner",
                width: "65px",
                height: "65px",
                style: normalizeStyle({ opacity: !iframeShow.value ? 1 : 0, zIndex: !iframeShow.value ? 99 : -1 }),
                viewBox: "0 0 66 66",
                xmlns: "http://www.w3.org/2000/svg"
              }, _hoisted_6, 4)),
              createElementVNode("span", {
                class: "tvb-sso-button_dialog-container-close",
                style: normalizeStyle({ opacity: iframeShow.value ? 1 : 0 }),
                onClick: _cache[0] || (_cache[0] = ($event) => iframeSrc.value = "")
              }, null, 4),
              iframeSrc.value ? (openBlock(), createElementBlock("iframe", {
                key: 0,
                class: "tvb-sso-button_dialog-container-iframe",
                style: normalizeStyle({ opacity: iframeShow.value ? 1 : 0 }),
                src: iframeSrc.value,
                onLoad: onSsoload
              }, null, 44, _hoisted_7)) : createCommentVNode("v-if", true),
              isLogin.value ? (openBlock(), createElementBlock("a", mergeProps({
                key: 1,
                href: unref(USER_LOGOUT)(unref(env) || "prod")
              }, _ctx.$attrs, {
                title: "\u767B\u51FA",
                style: { "position": "absolute", "bottom": "-60px", "z-index": "9", "color": "rgb(253 107 74)", "left": "calc(50% - 50px)", "height": "38px", "background": "rgb(255 255 255)", "width": "100px", "border-radius": "48px", "text-align": "center", "line-height": "38px", "cursor": "pointer", "box-shadow": "0 1px 6px #00000050", "font-size": "16px" },
                onClick: logout
              }), " \u767B\xA0\xA0\u51FA ", 16, _hoisted_8)) : createCommentVNode("v-if", true)
            ], 2)
          ], 2)
        ]))
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=SsoButton.vue2.mjs.map
